module.exports = __webpack_public_path__ + "icomoon.eot?35a7a9ba1333644da02577e83b69030e";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/icomoon/icomoon.eot
// module id = 916
// module chunks = 27